import { createSharedComposable } from "@vueuse/core"
import { onUnmounted, ref, watch } from "vue"
import { useMedia } from "./media"

export const useBottomBarVisibility = createSharedComposable(() => {
    const { isDesktop } = useMedia()
    const showBottomBar = ref(false)
    
    const checkScrollPosition = () => {
        if (typeof window === "undefined" || isDesktop.value) return
        showBottomBar.value = window.scrollY > 450
    }
    
    watch(isDesktop, (desktop) => {
        if (typeof window === "undefined") return
        window.removeEventListener("scroll", checkScrollPosition)
        if (desktop) {
            showBottomBar.value = false
        } else {
            window.addEventListener("scroll", checkScrollPosition, { passive: true })
            checkScrollPosition()
        }
    }, { immediate: true })
    
    onUnmounted(() => {
        if (typeof window !== "undefined") {
            window.removeEventListener("scroll", checkScrollPosition)
        }
    })
    
    return { showBottomBar }
}) 